/**
 * Componente wrapper que combina Input com botão de inserção de variáveis
 * Permite digitação normal e inserção de variáveis via botão {}
 * Similar ao TextareaWithVariables, mas para campos de texto de uma linha
 */

import { useRef, forwardRef } from 'react';
import { Input } from '@/components/ui/input';
import { VariableInsertButton } from './VariableInsertButton';
import { cn } from '@/lib/utils';

interface InputWithVariablesProps {
  tenantId: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  className?: string;
  disabled?: boolean;
}

export const InputWithVariables = forwardRef<HTMLInputElement, InputWithVariablesProps>(
  ({ tenantId, value, onChange, placeholder, maxLength, className, disabled }, ref) => {
    // Referência interna para o input
    const inputRef = useRef<HTMLInputElement>(null);

    return (
      <div className="relative">
        {/* Campo Input padrão com padding extra à direita para o botão */}
        <Input
          ref={(node) => {
            // Sincroniza ref interno e ref externo
            if (inputRef) {
              (inputRef as any).current = node;
            }
            if (typeof ref === 'function') {
              ref(node);
            } else if (ref) {
              ref.current = node;
            }
          }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          className={cn('pr-10', className)}
        />
        
        {/* Botão de inserção de variáveis posicionado à direita */}
        {/* Botão de inserção de variáveis posicionado à direita */}
        <div className="absolute top-1/2 right-2 -translate-y-1/2 flex items-center">
          <VariableInsertButton
            tenantId={tenantId}
            textareaRef={inputRef as unknown as React.RefObject<HTMLTextAreaElement>}
            onInsert={onChange}
          />
        </div>
      </div>
    );
  }
);

InputWithVariables.displayName = 'InputWithVariables';
